import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Users } from 'lucide-react';
import { EditorSection, Field } from '~/components/promotion/editor-section';
import { EntityMultiSelect } from '~/components/promotion/entity-multi-select';
import { MOCK_CUSTOMER_CATEGORIES, MOCK_CUSTOMERS } from '~/lib/lookups/mock';
import type { PromotionFormValues } from '~/lib/schemas/promotion';

export function CustomerRestrictionSection() {
	const { t } = useTranslation();
	const { control } = useFormContext<PromotionFormValues>();

	return (
		<EditorSection
			title={t('promotion.conditions.customerRestriction.title')}
			subtitle={t('promotion.conditions.customerRestriction.subtitle')}
			icon={Users}>
			<div className="grid grid-cols-2 gap-4">
				<Field
					label={t('promotion.conditions.customerRestriction.categories')}
					help={t('promotion.conditions.customerRestriction.categoriesHelp')}>
					<Controller
						control={control}
						name="customerCategoryIds"
						render={({ field }) => (
							<EntityMultiSelect
								value={field.value}
								onChange={field.onChange}
								options={MOCK_CUSTOMER_CATEGORIES}
								placeholder={t('promotion.conditions.customerRestriction.categoriesPlaceholder')}
							/>
						)}
					/>
				</Field>
				<Field
					label={t('promotion.conditions.customerRestriction.profiles')}
					help={t('promotion.conditions.customerRestriction.profilesHelp')}>
					<Controller
						control={control}
						name="customerIds"
						render={({ field }) => (
							<EntityMultiSelect
								value={field.value}
								onChange={field.onChange}
								options={MOCK_CUSTOMERS}
								placeholder={t('promotion.conditions.customerRestriction.profilesPlaceholder')}
							/>
						)}
					/>
				</Field>
			</div>
		</EditorSection>
	);
}
